import { gql } from '@apollo/client';

const SEARCH_USERS_QUERY = gql`
  query searchUsers(
    $searchText: String!
    $classroomIds: [Int!]
    $organizationIds: [Int!]
    $limit: Int
  ) {
    userSearch(
      searchText: $searchText
      classroomId: $classroomIds
      organizationId: $organizationIds
      where: { status: [ACTIVE, PENDING] }
      orderBy: { field: [LAST_NAME, FIRST_NAME, ID], direction: [ASC, ASC, DESC] }
      paging: { limit: $limit }
    ) {
      id
      username
      firstName
      lastName
      status
    }
  }
`;

export default SEARCH_USERS_QUERY;
